<template>
  <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
    <el-breadcrumb-item v-for="(item, index) in title" :key="index">{{
      item
    }}</el-breadcrumb-item>
    <!-- <el-breadcrumb-item>列表</el-breadcrumb-item> -->
  </el-breadcrumb>
</template>

<script>
export default {
  name: "BreadCrumb",
  data() {
    return {
      title: [],
    };
  },
  watch: {
    $route: {
      handler(n, o) {
        this.title = n.meta.title;
      },
      immediate: true,
    },
  },
  mounted() {},
};
</script>